import { render, staticRenderFns } from "./select-lens.vue?vue&type=template&id=5c096c6b&scoped=true"
import script from "./select-lens.vue?vue&type=script&lang=js"
export * from "./select-lens.vue?vue&type=script&lang=js"
import style0 from "./select-lens.vue?vue&type=style&index=0&id=5c096c6b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c096c6b",
  null
  
)

export default component.exports